import React, { useContext } from 'react';

/**
 * Context for the current user's avatar including avatar data and setters.
 */
export interface IUserAvatarContext {
  /** User's friendly name, which can be used as the image alt attribute. */
  friendlyname?: string | undefined;
  /** User's initials, which can be used in a placeholder avatar. */
  initials?: string | undefined;
  /** User avatar image URL including sas token. */
  src?: string | undefined;
  /** Value indicating whether a new upload is in progress. */
  uploading?: boolean;
  /** Setter to update the user's avatar image URL. */
  setSrc?: (value: string) => void;
  /** Optional handler to upload a new avatar image. */
  upload?: (file: File) => Promise<string>;
  /** Optional handler to remove the user's avatar image. */
  remove?: () => Promise<void>;
}

/** Empty context with no names or setters. */
const AvatarContext = React.createContext<IUserAvatarContext>({});

export const useAvatarContext = () => useContext(AvatarContext);
export const AvatarContextProvider = AvatarContext.Provider;
export const AvatarContextConsumer = AvatarContext.Consumer;
export default AvatarContext;
